(() => {
  const STORAGE_KEY = 'mt_contact_utm_v1'
  const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

  const readStored = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}
    } catch (error) {
      return {}
    }
  }

  const writeStored = (data) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    } catch (error) {}
  }

  const captureFromUrl = () => {
    const params = new URLSearchParams(window.location.search)
    const stored = readStored()
    const hasUtm = UTM_PARAMS.some((key) => params.has(key))

    if (hasUtm) {
      const next = { ...stored, source: window.location.href }

      UTM_PARAMS.forEach((key) => {
        if (params.has(key)) {
          next[key] = params.get(key)
        }
      })

      writeStored(next)
      return next
    }

    if (!stored.source) {
      const next = { ...stored, source: window.location.href }
      writeStored(next)
      return next
    }

    return stored
  }

  const isContactForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false
    if (!form.querySelector('[data-mt-utm-field]')) return false

    const action = form.getAttribute('action') || ''
    return action.includes('/contact') || form.querySelector('input[name="contact[email]"]')
  }

  const fillForm = (form) => {
    const data = captureFromUrl()

    form.querySelectorAll('[data-mt-utm-field]').forEach((input) => {
      const key = input.getAttribute('data-mt-utm-field')
      if (!key) return

      if (key === 'source') {
        input.value = data.source || window.location.href
        return
      }

      input.value = data[key] || ''
    })
  }

  const initForm = (form) => {
    if (!isContactForm(form) || form.__mtUtmInitialized) return

    form.__mtUtmInitialized = true
    fillForm(form)
    form.addEventListener('submit', () => fillForm(form))
  }

  const init = () => {
    captureFromUrl()
    document.querySelectorAll('form').forEach(initForm)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', init)
})()
